import { Cookies } from 'react-cookie';
import { CookieSerializeOptions } from 'cookie';

const cookie = new Cookies();

export const setCookie = (
    name: string,
    value: any,
    option?: CookieSerializeOptions
): void => {
    return cookie.set(name, value, {
        path: '/',
        ...option
    });
};

export const getCookie = (name: string) => cookie.get(name);

export const removeCookie = (name: string, option?: CookieSerializeOptions) => {
    cookie.remove(name, {
        path: '/',
        expires: new Date(0),
        maxAge: -1,
        ...option
    });
};
